export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl">桃花视频</span>
            </div>
            <p className="text-sm text-background-300/80 leading-relaxed">
              桃花视频提供<strong>91视频、91视频网站、久久视频、91在线视频</strong>等热门影视资源，免费在线观看高清电视剧全集和电影大全，流畅不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><a href="#cards" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">动作电影</a></li>
              <li><a href="#cards" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">悬疑惊悚</a></li>
              <li><a href="#cards" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">古装仙侠</a></li>
              <li><a href="#cards" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">国创动漫</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">快速入口</h4>
            <ul className="space-y-2">
              <li><a href="#ranking" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">热播排行榜</a></li>
              <li><a href="#updates" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">最新片单</a></li>
              <li><a href="#media" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">精彩预告</a></li>
              <li><a href="#faq" className="text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-300/80 leading-relaxed">
              桃花视频与多家优质内容方保持紧密合作，共同为观众打造丰富的影视观看体验。合作洽谈请联系商务邮箱。
            </p>
          </div>
        </div>

        <div className="border-t border-background-300/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/60">
            &copy; 2026 桃花视频 - 全网热门影视免费在线观看平台。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-300/60 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">回到顶部</a>
            <a href="#contact" className="text-xs text-background-300/60 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#about" className="text-xs text-background-300/60 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}